import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { MyTripsTicketNoComponent } from './mytrips-ticket-no.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [MyTripsTicketNoComponent],
  exports: [MyTripsTicketNoComponent]
})
export class MyTripsTicketNoModule {}
